import { Controller } from '@hotwired/stimulus'

export default class WaitingListPositionController extends Controller {
  static targets = ['count'];

  static values = {
    projectId: Number,
    subscriptionId: Number,
    position: Number,
  };

  connect() {
    this.channelSubscription = App.cable.subscriptions.create(
      {
        channel: 'ProjectLiveCollectChannel',
        project_id: this.projectIdValue,
      },
      {
        received: (data) => this.#applyBroadcast(data),
      }
    );
  }

  disconnect() {
    if (this.channelSubscription) {
      this.channelSubscription.unsubscribe();
      this.channelSubscription = null;
    }
  }

  positionValueChanged(value) {
    if (this.hasCountTarget) {
      this.countTarget.textContent = value;
    }
  }

  #applyBroadcast(data) {
    const transitionedId = data.transitioned_subscription_id;
    if (typeof transitionedId !== 'number') return;

    if (transitionedId === this.subscriptionIdValue) {
      this.positionValue = 0;
    } else if (transitionedId < this.subscriptionIdValue) {
      this.positionValue = Math.max(0, this.positionValue - 1);
    }

    if (this.positionValue === 0) {
      this.disconnect();
      window.location.reload();
    }
  }
}
